import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PageGetAllService } from '../../services';

export const fetchPageGetAll = createAsyncThunk(
    'pageGetAll/fetchPageGetAll',
    async () => {
        const response = await PageGetAllService()
        return response.result
    }
);

const pageGetAllSlice = createSlice({
    name: 'pageGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPageGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPageGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchPageGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default pageGetAllSlice.reducer;
